export const environment = {
  production: true,
  web_site: "https://dev.studiomap.fr",
  webflow_url: "https://dev-studiomap.webflow.io",
  api: "https://api.dev.studiomap.fr/api",
  api_base_link: "https://api.dev.studiomap.fr",
  stripe_pk: "pk_live_51IqzjML8SJyYJrpKnzUNAspWvqCNGSxfNvn0NLLEY6rEgtYYDMFYfNiLzPydfG46j4g3VZ672zk0TWBv3h3wzxHP00B4PFc1bZ",
  default_avatar : "assets/img/default.png",
  default_cover: "assets/img/cover.png",
  backend_passculture_pro: "backend.passculture.pro",
  stripe_dashboard_link : "https://dashboard.stripe.com",
  googleProvider: "426020724932-rgfjldeanr6l9ttb6ss58ve6gjs63jhb.apps.googleusercontent.com",
  facebookProvider: "310705248247030",

  // FranceConnect (use dev/staging config here)
  franceConnectAuthorizeUrl: "https://fcp-low.sbx.dev-franceconnect.fr/api/v2/authorize", // FC+ sandbox or staging
  franceConnectClientId: "bae29cc14fe06fd59c12f04a5c0a45c88376afd27ed9499c5c569c6d2766f5a0", // set your staging Client ID here
  franceConnectScope: "openid given_name family_name email birthdate",
  franceConnectLogoutReturnUrl: "https://auth.integ01.dev-franceconnect.fr/api/v2/client/logout-callback",
  franceConnectAcrValues: "eidas1",
  franceConnectClaims: { id_token: { amr: { essential: true } } },
};
